import React, { useState } from 'react';

const FIELD_LABELS = {
  player: 'Player',
  score: 'Score',
  kda: 'K/D/A',
  impact: 'Impact',
};

const MatchDetailsParseDebug = ({ result }) => {
  const [showCrops, setShowCrops] = useState(false);

  if (!result) return null;

  return (
    <div className="ocr-match-parse-panel">
      <div className="ocr-results-heading">
        <h4>Control Match Details Parsed</h4>
        <p>Temporary structured output. Nothing is applied to the Player Stats form yet.</p>
      </div>

      <div className="ocr-row-debug-meta">
        <span>Selected Team: {result.selectedTeamColor.toUpperCase()}</span>
        <span>Selected Rows: {result.selectedRowCount}</span>
        <span>Field Crops OCR'd: {result.fieldCropCount}</span>
        <span>Parse Time: {result.elapsedMs}ms</span>
      </div>

      {result.warnings.map((warning) => (
        <p className="ocr-row-warning" key={warning}>{warning}</p>
      ))}

      <button
        type="button"
        className="ocr-crop-toggle"
        onClick={() => setShowCrops((current) => !current)}
      >
        {showCrops ? 'Hide Field Crops' : 'Show Field Crops'}
      </button>

      <div className="ocr-match-records">
        {result.records.map((record, index) => (
          <article className="ocr-match-record" key={`${record.sourceRowId}-${index}`}>
            <header>
              <strong>Row {record.sourceRowIndex + 1}</strong>
              <span>{record.detectedName || 'Name not detected'}</span>
            </header>

            <dl>
              <div>
                <dt>Name</dt>
                <dd>{record.detectedName || 'FAILED'}</dd>
              </div>
              <div>
                <dt>Score</dt>
                <dd>{record.score ?? 'FAILED'}</dd>
              </div>
              <div>
                <dt>K</dt>
                <dd>{record.kills ?? 'FAILED'}</dd>
              </div>
              <div>
                <dt>D</dt>
                <dd>{record.deaths ?? 'FAILED'}</dd>
              </div>
              <div>
                <dt>A</dt>
                <dd>{record.assists ?? 'FAILED'}</dd>
              </div>
              <div>
                <dt>Impact</dt>
                <dd>{record.impact ?? 'FAILED'}</dd>
              </div>
            </dl>

            {record._warnings.length > 0 && (
              <div className="ocr-field-warnings">
                {record._warnings.map((warning) => (
                  <p key={warning}>{warning}</p>
                ))}
              </div>
            )}

            <div className="ocr-field-confidence">
              {Object.entries(record._ocr).map(([fieldKey, field]) => (
                <span key={fieldKey}>
                  {FIELD_LABELS[fieldKey]}: {typeof field.confidence === 'number' ? `${Math.round(field.confidence)}%` : 'N/A'}
                </span>
              ))}
            </div>

            {showCrops && (
              <div className="ocr-crop-grid">
                {Object.entries(record._crops).map(([fieldKey, crop]) => (
                  <figure key={fieldKey}>
                    <img src={crop.previewUrl} alt={`${FIELD_LABELS[fieldKey]} crop`} />
                    <figcaption>{FIELD_LABELS[fieldKey]}</figcaption>
                  </figure>
                ))}
              </div>
            )}
          </article>
        ))}
      </div>
    </div>
  );
};

export default MatchDetailsParseDebug;
